import type { RouteRecordRaw } from "vue-router";
import { createRouter, createWebHistory } from "vue-router";

import oidcAuth from "@/oidc";

import { baseConfig } from "./core/config";

const appMode = baseConfig.VITE_APP_MODE;

export enum Routes {
  HOME = "home",
  REQUEST_FORM = "request_form",
  NOT_FOUND = "not_found",
  OIDC_CALLBACK = "oidc_callback",
}

const adminRoutes = [Routes.HOME, Routes.OIDC_CALLBACK, Routes.NOT_FOUND];
const publicRoutes = [Routes.REQUEST_FORM, Routes.NOT_FOUND];

const authMeta = {
  authName: oidcAuth.authName,
};

const allRoutes: RouteRecordRaw[] = [
  {
    path: "/request/:processId?",
    name: Routes.REQUEST_FORM,
    component: () => import("./views/request/RequestView.vue"),
    beforeEnter: (to, _from, next) => {
      if (!to.query.management || !to.query.accessKey) {
        next({ name: Routes.NOT_FOUND });
        return;
      }
      next();
    },
    props: (route) => ({
      processId: route.params.processId,
      managementCompanyId: route.query.management,
      managementCompanyAccessKey: route.query.accessKey,
    }),
  },
  {
    path: "/",
    name: Routes.HOME,
    component: () => import("./views/managementCompany/ManagementCompanyList.vue"),
    meta: {
      ...authMeta,
    },
  },
  {
    path: "/oidc-callback",
    name: Routes.OIDC_CALLBACK,
    component: () => import("./views/auth/OidcCallback.vue"),
    meta: {
      isOidcCallback: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: Routes.NOT_FOUND,
    component: () => import("./views/NotFoundPage.vue"),
  },
];

const routes: RouteRecordRaw[] = allRoutes.filter((route) => {
  switch (appMode) {
    case "admin":
      return adminRoutes.includes(route.name as Routes);
    case "public":
      return publicRoutes.includes(route.name as Routes);
    default:
      return true;
  }
});

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
